import { memo } from "react";
import { Link } from "react-router-dom";

const PlutoCard = memo(({ data, projectInfo, isWatching = false }) => {
  const isPortrait = 
    data?.thumbnail_orientation === "PORTRAIT" || 
    projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT";
  
  const cardClassName = `pluto-card ${isPortrait ? 'portrait' : 'landscape'} ${isWatching ? 'continue-watching' : ''}`;

  const replaceImage = (error) => {
    if (isPortrait) {
      error.target.src = projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE_PORTRAIT;
    } else {
      error.target.src = projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE;
    }
  };

  const getItemLink = () => {
    if (data?.type === "UPCOMING_EVENT" || data?.type === "LIVE_EVENT") {
      return `/event/${data?.event_id}`;
    } else if (data?.type === "PODCAST") {
      return `/podcast/${data?.podcast_id}`;
    } else if (data?.type === "SHOW") {
      return `/show-details/${data?.vanity_url}`;
    } else if (data?.type === "NEWS") {
      return "/news";
    } else if (data?.type === "SHORTS") {
      return "/shorts";
    }  else if (data?.type === "VERTICAL_SHOW") {
       const showIdentifier = data?.vanity_url || data?.show_id;
       const episodeIdentifier = data?.video_vanity_url || data?.video_id;
          if (episodeIdentifier) {
            return `/vertical-show/${showIdentifier}/${episodeIdentifier}`
           } else {
            return `/vertical-show/${showIdentifier}`
          }           
    } else if (data?.video_vanity_url) {
      return `/videos/${data?.video_vanity_url}`;
    } else if (data?.url) {
      return data.url;
    } else {
      return "#";
    }
  };

  const itemLink = getItemLink();

  return (
    <Link to={itemLink} className="pluto-card-link">
      <div className={cardClassName}>
        <img 
          src={isPortrait 
            ? (data?.logo || (data?.thumbnail_orientation === "PORTRAIT" ? data?.thumbnail : null) || projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE_PORTRAIT) 
            : (data?.logo_thumb || (data?.thumbnail_orientation === "LANDSCAPE" ? data?.thumbnail : null) || projectInfo?.projectConfig?.config?.PLACEHOLDER_IMAGE)
          } 
          alt={data?.show_name || "Media"} 
          onError={replaceImage}
        />
        
        {isWatching && (
          <div className="progress-bar">
            <div 
              className="progress" 
              style={{ width: `${data.watched_percentage || 0}%` }}
            ></div>
          </div>
        )}
      </div>
    </Link>
  );
});

PlutoCard.displayName = "PlutoCard";
export default PlutoCard;
